import { api } from "@/app/services/api.service";
import { unwrapPayload } from "./uraApi";

export const INFOBIP_CREDENTIALS_PATH = "configuration/integration/infobip-credentials";

export type InfobipCredentials = {
  maskedAuthKey: string | null;
  baseUrl: string | null;
  configured: boolean;
};

export function parseInfobipCredentials(body: unknown): InfobipCredentials {
  if (body == null || typeof body !== "object") {
    return { maskedAuthKey: null, baseUrl: null, configured: false };
  }
  const record = body as Record<string, unknown>;
  const maskedAuthKey = record.authKey != null && record.authKey !== "" ? String(record.authKey) : null;
  const baseUrl = record.baseUrl != null && record.baseUrl !== "" ? String(record.baseUrl) : null;
  return {
    maskedAuthKey,
    baseUrl,
    configured: record.configured === true || maskedAuthKey != null,
  };
}

export async function fetchInfobipCredentials(): Promise<InfobipCredentials> {
  const res = await api().get(INFOBIP_CREDENTIALS_PATH);
  return parseInfobipCredentials(unwrapPayload(res));
}

export async function saveInfobipCredentials(payload: { authKey: string; baseUrl: string }) {
  await api().post(INFOBIP_CREDENTIALS_PATH, payload);
}

export async function deleteInfobipCredentials() {
  await api().delete(INFOBIP_CREDENTIALS_PATH);
}
